import { AuditSocialMediaAccountsController } from './audit-social-media-accounts.controller'

function auditSocialMediaAccounts () {
  return {
    restrict: 'E',
    scope: {
      filters: '<'
    },
    templateUrl: '/audit/directives/audit-social-media-accounts/audit-social-media-accounts.html?$$REVISION$$',
    controller: AuditSocialMediaAccountsController
  }
}

export { auditSocialMediaAccounts }
